/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { Session } from '../models';
import { SessionSummaryDto } from '../models';
import { SessionWithIngestionDto } from '../models';
/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get all sessions of a device
     * @param {string} device_id The unique identifier of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionControllerFindAllSessionsOfDevice: async (
      device_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'device_id' is not null or undefined
      if (device_id === null || device_id === undefined) {
        throw new RequiredError(
          'device_id',
          'Required parameter device_id was null or undefined when calling sessionControllerFindAllSessionsOfDevice.'
        );
      }
      const localVarPath = `/session/device/{device_id}`.replace(
        `{${'device_id'}}`,
        encodeURIComponent(String(device_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get the primary session of a patient in a specific date
     * @param {string} patient_id Patient ID
     * @param {string} start_date Date in ISO format, e.g. 2021-01-01
     * @param {string} end_date Date in ISO format, e.g. 2021-01-01
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionControllerGetPrimarySessionOfPatientByDate: async (
      patient_id: string,
      start_date: string,
      end_date: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'patient_id' is not null or undefined
      if (patient_id === null || patient_id === undefined) {
        throw new RequiredError(
          'patient_id',
          'Required parameter patient_id was null or undefined when calling sessionControllerGetPrimarySessionOfPatientByDate.'
        );
      }
      // verify required parameter 'start_date' is not null or undefined
      if (start_date === null || start_date === undefined) {
        throw new RequiredError(
          'start_date',
          'Required parameter start_date was null or undefined when calling sessionControllerGetPrimarySessionOfPatientByDate.'
        );
      }
      // verify required parameter 'end_date' is not null or undefined
      if (end_date === null || end_date === undefined) {
        throw new RequiredError(
          'end_date',
          'Required parameter end_date was null or undefined when calling sessionControllerGetPrimarySessionOfPatientByDate.'
        );
      }
      const localVarPath =
        `/session/primary_session/{patient_id}/{start_date}/{end_date}`
          .replace(`{${'patient_id'}}`, encodeURIComponent(String(patient_id)))
          .replace(`{${'start_date'}}`, encodeURIComponent(String(start_date)))
          .replace(`{${'end_date'}}`, encodeURIComponent(String(end_date)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Flat list of session data accessible to the authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionControllerGetSessionSummaries: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/session/summary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all sessions of a device
     * @param {string} device_id The unique identifier of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionControllerFindAllSessionsOfDevice(
      device_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<Session>>>
    > {
      const localVarAxiosArgs = await SessionsApiAxiosParamCreator(
        configuration
      ).sessionControllerFindAllSessionsOfDevice(device_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get the primary session of a patient in a specific date
     * @param {string} patient_id Patient ID
     * @param {string} start_date Date in ISO format, e.g. 2021-01-01
     * @param {string} end_date Date in ISO format, e.g. 2021-01-01
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionControllerGetPrimarySessionOfPatientByDate(
      patient_id: string,
      start_date: string,
      end_date: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SessionWithIngestionDto>>>
    > {
      const localVarAxiosArgs = await SessionsApiAxiosParamCreator(
        configuration
      ).sessionControllerGetPrimarySessionOfPatientByDate(
        patient_id,
        start_date,
        end_date,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Flat list of session data accessible to the authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionControllerGetSessionSummaries(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SessionSummaryDto>>>
    > {
      const localVarAxiosArgs =
        await SessionsApiAxiosParamCreator(
          configuration
        ).sessionControllerGetSessionSummaries(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Get all sessions of a device
     * @param {string} device_id The unique identifier of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionControllerFindAllSessionsOfDevice(
      device_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<Session>>> {
      return SessionsApiFp(configuration)
        .sessionControllerFindAllSessionsOfDevice(device_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get the primary session of a patient in a specific date
     * @param {string} patient_id Patient ID
     * @param {string} start_date Date in ISO format, e.g. 2021-01-01
     * @param {string} end_date Date in ISO format, e.g. 2021-01-01
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionControllerGetPrimarySessionOfPatientByDate(
      patient_id: string,
      start_date: string,
      end_date: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SessionWithIngestionDto>>> {
      return SessionsApiFp(configuration)
        .sessionControllerGetPrimarySessionOfPatientByDate(
          patient_id,
          start_date,
          end_date,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Flat list of session data accessible to the authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sessionControllerGetSessionSummaries(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SessionSummaryDto>>> {
      return SessionsApiFp(configuration)
        .sessionControllerGetSessionSummaries(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
  /**
   *
   * @summary Get all sessions of a device
   * @param {string} device_id The unique identifier of the device
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public async sessionControllerFindAllSessionsOfDevice(
    device_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<Session>>> {
    return SessionsApiFp(this.configuration)
      .sessionControllerFindAllSessionsOfDevice(device_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get the primary session of a patient in a specific date
   * @param {string} patient_id Patient ID
   * @param {string} start_date Date in ISO format, e.g. 2021-01-01
   * @param {string} end_date Date in ISO format, e.g. 2021-01-01
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public async sessionControllerGetPrimarySessionOfPatientByDate(
    patient_id: string,
    start_date: string,
    end_date: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SessionWithIngestionDto>>> {
    return SessionsApiFp(this.configuration)
      .sessionControllerGetPrimarySessionOfPatientByDate(
        patient_id,
        start_date,
        end_date,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Flat list of session data accessible to the authenticated user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public async sessionControllerGetSessionSummaries(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SessionSummaryDto>>> {
    return SessionsApiFp(this.configuration)
      .sessionControllerGetSessionSummaries(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
